import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { propTypes as formPropTypes, formValues } from 'redux-form'
import { lpForm } from 'lp-form'
import { SubmitButton } from 'lp-components'
import { TermsAgreementField } from 'member-portal/components'

const propTypes = {
  ...formPropTypes,
  showTermsAndConditions: PropTypes.bool,
}

function NoCreditCardRequiredForm({
  handleSubmit,
  showTermsAndConditions = false,
  submitting,
}) {
  return (
    <form className="cc-details-block" onSubmit={handleSubmit} noValidate>
      <div className="group-block">
        <div className="payment-form-empty-cc">Credit Card is not required</div>
      </div>

      {showTermsAndConditions && (
        <>
          <hr className="divider" />
          <TermsAgreementField />
        </>
      )}

      <div className="group button-group">
        <SubmitButton submitting={submitting}>
          {submitting ? 'Processing Transaction...' : 'Confirm Membership'}
        </SubmitButton>
      </div>
    </form>
  )
}

NoCreditCardRequiredForm.propTypes = propTypes

export default compose(
  lpForm({
    name: 'NoCreditCardRequiredForm',
  }),
  formValues('termsAgreement'),
)(NoCreditCardRequiredForm)
